"use client";
import type { ReactElement } from "react";
import { AXIS_HEIGHT, HOVER_TRANSITION, } from "./gantt-constants";
import type { GanttLabelTaskRowModel } from "./gantt-label-row-selectors";
import type { GanttTaskRowLayout } from "./gantt-types";
import { CmarkdownLabelText } from "../Cmarkdowntext/CmarkdownLabelText";
export interface GanttLabelTaskRowProps {
    taskRow: GanttTaskRowLayout;
    model: GanttLabelTaskRowModel;
}
export function GanttLabelTaskRow({ taskRow, model, }: GanttLabelTaskRowProps): ReactElement {
    return (
      <div data-el="Cmarkdowngantt/LabelTaskRow/Entry" style={{
            position: "absolute",
            top: taskRow.y - AXIS_HEIGHT,
            left: 0,
            width: "100%",
            height: taskRow.height,
            padding: "0 12px",
            display: "flex",
            alignItems: "center",
            fontSize: 12,
            fontWeight: model.fontWeight,
            color: model.color,
            backgroundColor: model.background,
            boxShadow: model.boxShadow,
            opacity: model.opacity,
            transition: HOVER_TRANSITION,
            cursor: "default",
        }}>
        <CmarkdownLabelText dataElScope="Cmarkdowngantt/GanttLabelTaskRow" content={model.taskLabel} size={12} weight={model.markdownWeight} style={{ minWidth: 0, paddingLeft: 12, overflow: "hidden" }} paragraphStyle={{ marginBottom: 0, minWidth: 0 }} textStyle={{
            color: "inherit",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }}/>
      </div>
    );
}
